import axios from 'axios';
import kali from 'kali';

import {
	getSession,
} from 'Vulture/Session.js';

import {
	broncoURL,
	commitHash,
} from 'Vulture/ENV.js';

import {
	getFDValue,
} from 'Vulture/Helpers.js';

// In-flight request deduplication: concurrent calls to the same endpoint
// with the same parameters return the same promise instead of firing duplicate requests.
const _inflight = {};

const fetchAccounts = async function () {
	const session = getSession();
	let url = `${broncoURL}/accounts`;
	let body = {
		user: session.user,
	};

	const headers = {
		headers: {
			'X-Auth-Session': session.session,
			'X-Spark-API-version': commitHash,
		},
	};

	try {
		let res = await axios.post(url, body, headers);
		console.log(res);
		if (res.status !== 200) {
			debugger;
		}

		return res.data;
	} catch (err) {
		console.error(err);
		// debugger;
	}
};

// fetchAccountList loads only the user's accessible accounts (uuid + display_name)
// for the search/landing — a small, fast call that avoids the heavy
// permission-protected /accounts tree. The full account data loads via fetchAccount
// once an account is selected.
const fetchAccountList = async function () {
	const session = getSession();
	let url = `${broncoURL}/accounts/list`;

	try {
		let res = await axios.get(url, {
			headers: {
				'X-Auth-Session': session.session,
			},
		});

		return res.data; // { accounts: [{ uuid, display_name }] }
	} catch (err) {
		console.error(err);
	}
};

const fetchAccount = async function (accountUUID, systemGroupUUID) {
	const session = getSession();

	let url = `${broncoURL}/account`;
	let body = {
		user:         session.user,
		account:      accountUUID,
		system_group: systemGroupUUID,
	};

	const headers = {
		headers: {
			'X-Auth-Session':      session.session,
			'X-Spark-API-version': commitHash,
		},
	};

	try {
		let res = await axios.post(url, body, headers);
		return res.data;
	} catch (err) {
		console.error(err);
	}
};

const fetchAccountListingConfig = async function (accountUUID) {
	const session = getSession();

	let url = `${broncoURL}/account/listing/config`;
	let body = {
		user:    session.user,
		account: accountUUID,
	};

	const headers = {
		headers: {
			'X-Auth-Session':      session.session,
			'X-Spark-API-version': commitHash,
		},
	};

	try {
		let res = await axios.post(url, body, headers);
		return res.data;
	} catch (err) {
		console.error(err);
	}
};

const fetchAccountTemplates = async function (accountUUID) {
	const key = `templates:${accountUUID}`;
	if (_inflight[key]) return _inflight[key];

	const promise = (async () => {
		const session = getSession();

		let url = `${broncoURL}/account/templates`;
		let body = {
			user:    session.user,
			account: accountUUID,
		};

		const headers = {
			headers: {
				'X-Auth-Session':      session.session,
				'X-Spark-API-version': commitHash,
			},
		};

		try {
			let res = await axios.post(url, body, headers);
			if (res.status !== 200) {
				debugger;
			}

			return res.data;
		} catch (err) {
			console.error(err);
		}
	})();

	_inflight[key] = promise;
	try { return await promise; }
	finally { delete _inflight[key]; }
};

const fetchAccountSystems = async function (accountUUID) {
	const key = `systems:${accountUUID}`;
	if (_inflight[key]) return _inflight[key];

	const promise = (async () => {
		const session = getSession();

		let url = `${broncoURL}/account/systems`;
		let body = {
			user:    session.user,
			account: accountUUID,
		};

		const headers = {
			headers: {
				'X-Auth-Session':      session.session,
				'X-Spark-API-version': commitHash,
			},
		};

		try {
			let res = await axios.post(url, body, headers);
			if (res.status !== 200) {
				debugger;
			}

			return res.data;
		} catch (err) {
			console.error(err);
		}
	})();

	_inflight[key] = promise;
	try { return await promise; }
	finally { delete _inflight[key]; }
};

const fetchAccountSystem = async function (accountUUID, systemUUID) {
	const session = getSession();

	let url = `${broncoURL}/account/system`;
	let body = {
		user:    session.user,
		account: accountUUID,
		system:  systemUUID,
	};

	const headers = {
		headers: {
			'X-Auth-Session':      session.session,
			'X-Spark-API-version': commitHash,
		},
	};

	try {
		let res = await axios.post(url, body, headers);
		if (res.status !== 200) {
			debugger;
		}

		return res.data;
	} catch (err) {
		console.error(err);
	}
};

const updateSearch = async (columnName, value, uuids = []) => {
	const sessionKey = getSession().session;

	const body = {};

	switch (columnName) {
	case 'nameFilter':
		body.col = 'name';
		body.search = value;
		break;
	case 'salesforceFilter':
		body.col = 'sfid';
		body.search = value;
		break;
	case 'systemGroupNameFilter':
		body.col = 'system_group';
		body.search = value;
		break;
	case 'macAddressFilter':
		body.col = 'mac_address';
		body.search = value.split(':').join('');
		break;
	default:
		break;
	}

	if (uuids.length > 0) {
		body.uuid = uuids;
	}

	const opts = {
		method:  'POST',
		headers: {
			'content_type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
		body,
	};

	let retVal;

	await new kali(opts).get(`${broncoURL}/account/search`, {
		success: (_kail, res, data) => {
			retVal = data;
		},

		failure: (_kali, err) => {
			let errorMessage = String(err);
			if (errorMessage.indexOf('Failed to fetch') !== -1) {
				retVal = {
					err: errorMessage,
				};
			}
		},
	}, true);

	return retVal;
};

const saveNewAccount = async (accountName, id) => {
	const sessionKey = getSession().session;

	let opts = {
		method:  'POST',
		headers: {
			'content_type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
		body: {
			'display_name':      accountName,
			'salesforce_id_val': id,
		},
	};

	let retVal;

	await new kali(opts).post(`${broncoURL}/account/new`, {
		success: (_kali, res, data) => {
			retVal = data;
		},

		failure: (_kali, res, err) => {
			if (err !== undefined) {
				retVal = {
					err,
				};
			}
		},
	});

	return retVal;
};

const deleteAccount = async (fd, accountUUID) => {
	const sessionKey = getSession().session;

	let retVal;

	const url = `${broncoURL}/account/delete/${accountUUID}`;

	const res = await fetch(url, {
		method:  'DELETE',
		headers: {
			'content_type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
	});

	if (res.status === 200) {
		retVal = true;
	} else {
		console.error(await res.json());

		alert('Please make sure the accountUUID is not associated to any other users.');
	}

	return retVal;
};

// Column headers of the bulk-account-import CSV. The server ignores the header row's
// contents, but the order is significant: name first, Salesforce ID second.
const ACCOUNT_IMPORT_HEADERS = [ 'Account Name', 'Salesforce ID', ];

// Server-side cap in bronco's HandleAccountsImport (maxAccountImportRows). Duplicated here so
// the UI can block an oversized file before uploading it.
const MAX_ACCOUNT_IMPORT_ROWS = 50;

/**
 * Builds the blank 2-column CSV handed out by the "Get Template" button.
 *
 * @returns {string} CSV text, quoted headers, CRLF line ending
 */
const buildAccountTemplateCSV = () => {
	const headerRow = ACCOUNT_IMPORT_HEADERS.map((header) => {
		return `"${header}"`;
	}).join(',');

	return `${headerRow}\r\n`;
};

/**
 * Bulk-creates accounts from a CSV. Internal admin only — the server rejects anyone else
 * with a 403.
 *
 * @param {File} CSVfile
 * @param {string} checksum hex SHA-256 of the file, from Vulture/Checksum
 * @returns {Promise<{created: Array, skipped: Array}|{err: string}>}
 */
const importAccounts = async (CSVfile, checksum) => {
	const sessionKey = getSession().session;

	const body = new FormData();
	body.append('file', CSVfile);
	body.append('checksum', checksum);

	try {
		// Deliberately no Content-Type header — the browser has to set the multipart boundary.
		const res = await fetch(`${broncoURL}/accounts/import`, {
			body,
			method:  'POST',
			headers: {
				'X-Auth-Session': sessionKey,
			},
		});

		const data = await res.json();

		if (res.status !== 200) {
			return {
				err: typeof data === 'string' ? data : JSON.stringify(data),
			};
		}

		return data;
	} catch (err) {
		return {
			err: err.message || String(err),
		};
	}
};

const fetchDataSets = (setDataSets) => {
	const session = getSession();

	let url = `${broncoURL}/data_sets`;

	let body = {
		user: session.user,
	};

	let headers = {
		'X-Auth-Session': session.session,
	};

	axios
		.post(url, body, {
			headers,
		})
		.then((res) => {
			setDataSets(res.data.dataSets);
		})
		.catch((err) => {
			alert(err);
		});
};

export {
	fetchAccount,
	fetchAccountListingConfig,
	fetchAccounts,
	fetchAccountList,
	fetchAccountSystem,
	fetchAccountSystems,
	fetchAccountTemplates,
	updateSearch,
	saveNewAccount,
	deleteAccount,
	fetchDataSets,
	buildAccountTemplateCSV,
	importAccounts,
	ACCOUNT_IMPORT_HEADERS,
	MAX_ACCOUNT_IMPORT_ROWS,
};